export default __webpack_public_path__ + "static/media/network-diagram.3b309a7f.png";